import { axiosInstance } from 'app/utils/axiosConfig'

import { endpoints } from './endpoints'

export const executeLogout = async (): Promise<void> => {
  return axiosInstance.delete(endpoints.logout)
}
